import { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import styled from "styled-components";

const DeleteButton = styled(Button)`
	border-top-left-radius: 5px;
	border-bottom-left-radius: 5px;
	border-top-right-radius: 5px;
	border-bottom-right-radius: 5px;
	height: 32px;
	width: 32px;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 4px;
`;

export const DeleteComponent = ({
	selectedRows,
	setRefreshTrigger,
	deleteById
}: {
	selectedRows: any[];
	setRefreshTrigger: Function;
	deleteById: Function;
}) => {
	const [deletePressedCount, setDeletePressedCount] = useState(0);
	return (
		<DeleteButton
			title="Xóa đơn thuê, nhấn 3 lần để xóa"
			className="btn btn-danger"
			type="button"
			onClick={async () => {
				console.log("deletePressedCount", deletePressedCount);
				if (selectedRows.length === 0) {
					return toast.error("Chọn ít nhất 1 đơn thuê để xóa");
				}
				if (deletePressedCount === 0) {
					toast.warning("Nhấn 2 lần nữa để xóa");
					setDeletePressedCount(1);
					return;
				}
				if (deletePressedCount === 1) {
					toast.dismiss();
					toast.warning("Nhấn 1 lần nữa để xóa");
					setDeletePressedCount(2);
					return;
				}
				if (deletePressedCount === 2) {
					toast.dismiss();
					await Promise.all(
						selectedRows.map(async (row) => {
							try {
								await deleteById(row.id);
							} catch (e: any) {
								// Note: too lazy and clumpsy to do a clearSeletecRows for the DataTable, so just ignore the error instead
								if (e.toString().includes("not exists")) {
									return;
								}
								toast.error(`Lỗi deleteProduct|${e.toString()}`);
							}
						})
					);

					setDeletePressedCount(0);
					setRefreshTrigger((prev: boolean) => !prev);
					return;
				}
			}}
		>
			🚮
		</DeleteButton>
	);
};
